/**
 * Builds a follow-up message when update-route's voiceUrlSync indicates the
 * previous Twilio number's voice URL was updated (e.g. pointed at default).
 *
 * @param {object} [voiceUrlSync] - voiceUrlSync from update-route response
 * @param {{ newPhoneNumber?: string|null }} [opts]
 * @returns {string|null}
 */
export function getVoiceUrlOldNumberUpdatedMessage(voiceUrlSync, opts = {}) {
  if (!voiceUrlSync || typeof voiceUrlSync !== "object") return null;
  const oldStep = voiceUrlSync.steps?.oldNumber;
  if (!oldStep || oldStep.status !== "ok") return null;

  const { newPhoneNumber } = opts;
  const oldPhone = oldStep.phone;
  const newStep = voiceUrlSync.steps?.newNumber;
  const newPhone =
    newStep?.status === "ok" && newStep.phone
      ? newStep.phone
      : newPhoneNumber || null;

  const newPhoneLabel = newPhone || "the new number for this route";

  const oldClause = oldPhone
    ? `Calls to the previous number (${oldPhone}) will`
    : "Calls to the previous number will";

  return (
    `We updated your Twilio voice URLs: this route is now connected to ${newPhoneLabel}. ` +
    `${oldClause} play the default message unless you connect that line to another route in Twilanswer or change the voice settings in the Twilio console.`
  );
}
